module.exports = __webpack_public_path__ + "img/Hero.1c2c337e.png";